import { isDefined } from "@omni/utils/helper.utils";
import { createContext, MouseEvent, ReactNode, RefObject, use } from "react";

type OverlayContextValue = {
    open: boolean;
    backdrop: boolean;
    overlayHeader?: boolean;
    scrollLock?: boolean;
    mountElementRef: RefObject<HTMLDivElement | null>;
    onClose: (event: MouseEvent<HTMLDivElement>) => void;
};

type OverlayContextProviderProps = {
    open: boolean;
    backdrop: boolean;
    overlayHeader?: boolean;
    scrollLock?: boolean;
    mountElementRef: RefObject<HTMLDivElement | null>;
    onClose: (event: MouseEvent<HTMLDivElement>) => void;
    children?: ReactNode;
};

export const OverlayContext = createContext<OverlayContextValue | undefined>(
    undefined
);
OverlayContext.displayName = "OverlayContext";

export const OverlayContextProvider = ({
    children,
    ...props
}: OverlayContextProviderProps) => {
    return <OverlayContext value={props}>{children}</OverlayContext>;
};

export const useOverlayContext = () => {
    const context = use<OverlayContextValue | undefined>(OverlayContext);

    if (!isDefined(context)) {
        throw new Error(`${OverlayContext.displayName} is undefined.`);
    }

    return context;
};
